/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgTractor48(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={48}
      height={49}
      fill='none'
      viewBox='0 0 48 49'
      {...props}
    >
      <path
        fill='#D6F5FF'
        fillRule='evenodd'
        d='M2 43.057v2.05a2.502 2.502 0 002.503 2.502h7.502a2.495 2.495 0 002.495-2.495v-2.047l-.27.22A9.48 9.48 0 012 43.056zm44 0v2.05a2.502 2.502 0 01-2.502 2.502h-7.502a2.495 2.495 0 01-2.496-2.495v-2.047l.27.22a9.48 9.48 0 0012.23-.23zM17.244 14.87c-1.384.438-2.313 1.464-2.744 3.131v7.5h-2v12l4.744-3V14.87zm13.512 0l2.744 2.143V25.5h2v12l-4.744-3V14.87z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M22.5 48a.5.5 0 01-.5-.5V41a.5.5 0 01.5-.5h3a.5.5 0 01.5.5v6.5a.5.5 0 01-.5.5h-3z'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeLinejoin='round'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M20 13.5c0-2.113 1.793-3.828 4-3.828s4 1.715 4 3.828'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M33.5 18V4.75h-3v9.989'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M2 25.5V45a3 3 0 003 3h6.5a3 3 0 003-3V25.5M6.5 17v2.5'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M26.5 25h-5M26.5 28.5h-5'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M32 .75v3.5M46 25.5V45a3 3 0 01-3 3h-6.5a3 3 0 01-3-3V25.5'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeLinejoin='round'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M6.5 13a2 2 0 11-.001 4.001A2 2 0 016.5 13zm35 0a2 2 0 10.001 4.001A2 2 0 0041.5 13z'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M41.5 17v2.5'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M24 13.5c-4.397 0-7.018 1.184-8.36 2.064a2.58 2.58 0 00-1.138 2.14C14.5 21.807 14.5 35 14.5 35c3.681-.187 6.797.38 9.5 1.5 2.703-1.12 5.819-1.687 9.5-1.5V17.703c0-.858-.426-1.661-1.139-2.141C31.018 14.684 28.398 13.5 24 13.5v0z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M33.5 25H47v-5H1v5h13.5'
      />
      <path
        stroke='currentColor'
        strokeLinejoin='round'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M24 36.5v3.25'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M14.5 28c-.399 2.118-1.389 4.187-5 4.25M14.5 34.5c-.399 2.118-1.389 4.187-5 4.25M14.5 40.5c-.399 2.118-1.389 4.187-5 4.25M2 28c.399 2.118 1.389 4.187 5 4.25M2 34.5c.399 2.118 1.389 4.187 5 4.25M2 40.5c.399 2.118 1.389 4.187 5 4.25M46 27.75c-.399 2.118-1.389 4.187-5 4.25M46 34.25c-.399 2.118-1.389 4.187-5 4.25M46 40.25c-.399 2.118-1.389 4.187-5 4.25M33.5 27.75c.393 2.118 1.367 4.187 4.925 4.25M33.5 34.25c.393 2.118 1.367 4.187 4.925 4.25M33.5 40.25c.393 2.118 1.367 4.187 4.925 4.25'
      />
    </svg>
  );
}

export default SvgTractor48;
